export default function load() {
	return (dispatch) => {
		dispatch({
			type: 'LOAD',
		});
	};
}